module.exports = __webpack_public_path__ + "static/media/organ.6a556889.jpg";